import { render, staticRenderFns } from "./myLiveList.vue?vue&type=template&id=74d04267&scoped=true"
import script from "./myLiveList.vue?vue&type=script&lang=js"
export * from "./myLiveList.vue?vue&type=script&lang=js"
import style0 from "./myLiveList.vue?vue&type=style&index=0&id=74d04267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d04267",
  null
  
)

export default component.exports